<template>
  <!-- 抄送节点 -->
  <div class="">
    <el-form label-width="2.4rem">
      <el-form-item label="节点名称">
        <el-input v-model="nodeInfo.nodeName"/>
      </el-form-item>
      <el-form-item label="抄送人员为">
        <el-select v-model="nodeInfo.employeeType">
          <el-option label="指定人员" :value="0"/>
          <el-option label="申报人员部门负责人" :value="1"/>
        </el-select>
      </el-form-item>
      <!-- 指定人员时加载职员选择组件，与审批节点保持一致 -->
      <el-form-item label="抄送人员" v-if="nodeInfo.employeeType === 0">
        <employee-select-sort ref="employeeSelectSort" v-model="nodeInfo.employeeRange"/>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import EmployeeSelectSort from "@/components/h5/data/EmployeeSelectSort.vue";

export default {
  props: {
    data: {

    }
  },
  watch: {
    data: {
      handler() {
        this.init();
      }
    }
  },
  name: "LogicFlowNodeDuplicate",
  components: {
    EmployeeSelectSort
  },
  data() {
    return {
      nodeInfo: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.nodeInfo = {...this.data};
    },
    // 返回数据，并进行验证
    getData() {
      let data = {...this.nodeInfo};
      // 指定人员：从选择组件取职员列表，生成画布上的展示文案
      if (data.employeeType === 0 && this.$refs.employeeSelectSort) {
        let employees = this.$refs.employeeSelectSort.getEmployeeList() || [];
        let names = [];
        for (let i = 0; i < employees.length; i++) {
          if (i < 3) {
            names.push(employees[i].employeeName);
          } else {
            names.push("等");
            break;
          }
        }
        data.message = names.length > 0 ? "抄送给：" + names.join(",") : "";
      } else if (data.employeeType === 1) {
        data.message = "抄送给申报人员的部门负责人";
      }
      return data;
    },
  }
};
</script>

<style lang="scss" scoped>

</style>
